// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
** Breakpoints
*/
/*
** Black
*/
/*
** Grey
*/
/*
** Colors
*/
/*
** Font
*/
.Pagination {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style-type: none; }
.PaginationControl {
  display: flex;
  align-items: center; }
.Control {
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  margin: 0 2px;
  fill: #BBBBBB; }
.Control-active {
    fill: #333333;
    cursor: pointer;
    transition: fill 0.2s ease-in-out; }
.Control-active:hover {
      fill: #000000;
      transition: fill 0.2s ease-in-out; }
/*
** Breakpoints
*/
/*
** Black
*/
/*
** Grey
*/
/*
** Colors
*/
/*
** Font
*/
.Page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin: 0 2px;
  color: #666666;
  background-color: transparent;
  font-size: 14px;
  border-radius: 3px;
  box-sizing: border-box;
  border-color: transparent;
  cursor: pointer;
  outline: 0;
  user-select: none; }
.Page:hover {
    border: 1px solid #DEDEDE; }
.Page-active {
    color: #333333;
    border: 1px solid #DEDEDE; }
.DotsHolder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin: 0 2px;
  box-sizing: border-box; }
.Dots {
  width: 8px;
  height: 4px;
  fill: #BBBBBB; }
`, "",{"version":3,"sources":["webpack://./../../node_modules/.pnpm/@hennge+vue3-pagination@1.0.17_vue@3.4.18/node_modules/@hennge/vue3-pagination/dist/vue3-pagination.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;;CAEC;AACD;;CAEC;AACD;;CAEC;AACD;;CAEC;AACD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,qBAAqB,EAAE;AAEzB;EACE,aAAa;EACb,mBAAmB,EAAE;AAEvB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa,EAAE;AACf;IACE,aAAa;IACb,eAAe;IACf,iCAAiC,EAAE;AACnC;MACE,aAAa;MACb,iCAAiC,EAAE;AAEzC;;CAEC;AACD;;CAEC;AACD;;CAEC;AACD;;CAEC;AACD;;CAEC;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,iBAAiB,EAAE;AACnB;IACE,yBAAyB,EAAE;AAC7B;IACE,cAAc;IACd,yBAAyB,EAAE;AAE/B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAE;AAE1B;EACE,UAAU;EACV,WAAW;EACX,aAAa,EAAE","sourcesContent":["/*\n** Breakpoints\n*/\n/*\n** Black\n*/\n/*\n** Grey\n*/\n/*\n** Colors\n*/\n/*\n** Font\n*/\n.Pagination {\n  display: flex;\n  flex-flow: row;\n  flex-wrap: wrap;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n\n.PaginationControl {\n  display: flex;\n  align-items: center; }\n\n.Control {\n  position: relative;\n  display: block;\n  width: 18px;\n  height: 18px;\n  margin: 0 2px;\n  fill: #BBBBBB; }\n  .Control-active {\n    fill: #333333;\n    cursor: pointer;\n    transition: fill 0.2s ease-in-out; }\n    .Control-active:hover {\n      fill: #000000;\n      transition: fill 0.2s ease-in-out; }\n\n/*\n** Breakpoints\n*/\n/*\n** Black\n*/\n/*\n** Grey\n*/\n/*\n** Colors\n*/\n/*\n** Font\n*/\n.Page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin: 0 2px;\n  color: #666666;\n  background-color: transparent;\n  font-size: 14px;\n  border-radius: 3px;\n  box-sizing: border-box;\n  border-color: transparent;\n  cursor: pointer;\n  outline: 0;\n  user-select: none; }\n  .Page:hover {\n    border: 1px solid #DEDEDE; }\n  .Page-active {\n    color: #333333;\n    border: 1px solid #DEDEDE; }\n\n.DotsHolder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin: 0 2px;\n  box-sizing: border-box; }\n\n.Dots {\n  width: 8px;\n  height: 4px;\n  fill: #BBBBBB; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
